import { some } from 'lodash/fp';
import { connect } from 'react-redux';

import { Route, RouteConfig } from '@mews-distributor/common';
import { RouteConfiguration } from '@mews-distributor/common/src/enums/Route';
import { ProgressIndicatorWrapper } from '@mews-distributor/ui';
import { LocalizedText, useLocalizeText } from '@mews/framework';

import { TextKey } from '@mews/text-keys';
import { tabClickHandler } from '../../../actions/navigation';
import { isAppInitialized } from '../../../modules/app/selectors';
import { ApplicationState } from '../../../types';
import {
    getActiveTab,
    getCompletedTabsList,
    getEnabledTabsList,
    getTabs,
    isMenuEnabled,
    isStepbarVisible,
} from './menuSelectors';

interface BaseNavbarProps extends Omit<React.ComponentProps<typeof ProgressIndicatorWrapper>, 'steps'> {
    rendered: boolean;
    tabs: Route[];
    enabledTabs: RouteConfiguration[];
    completedTabs: RouteConfiguration[];
    activeTab: RouteConfiguration;
    disabled: boolean;
}
const BaseNavbar = ({ rendered, tabs, enabledTabs, completedTabs, disabled, ...other }: BaseNavbarProps) => {
    const localizeText = useLocalizeText();

    if (!rendered) {
        return null;
    }

    const steps = tabs.map((tab) => {
        const { icon, nameKey } = RouteConfig[tab];
        return {
            value: tab,
            label: <LocalizedText textKey={nameKey as string as TextKey} />,
            ariaLabel: localizeText({
                textKey: TextKey.LinkTo,
                substitutes: { destination: localizeText({ textKey: nameKey as string as TextKey }) },
            }),
            icon,
            editable: disabled ? false : some((enabledTab) => enabledTab.name === tab, enabledTabs),
            completed: disabled ? false : some((completedTab) => completedTab.name === tab, completedTabs),
        };
    });

    return <ProgressIndicatorWrapper steps={steps} {...other} />;
};

export const Navbar = connect(
    (state: ApplicationState) => ({
        rendered: isStepbarVisible(state) && isAppInitialized(state),
        disabled: !isMenuEnabled(state),
        tabs: getTabs(state),
        enabledTabs: getEnabledTabsList(state),
        completedTabs: getCompletedTabsList(state),
        activeTab: getActiveTab(state),
    }),
    {
        onClick: tabClickHandler,
    }
)(BaseNavbar);
